"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadVersion = exports.tryGetFromCache = void 0;
const core = __importStar(require("@actions/core"));
const tc = __importStar(require("@actions/tool-cache"));
const io = __importStar(require("@actions/io"));
const utils_1 = require("../utils");
function tryGetFromCache(arch, version) {
    core.debug(`Trying to get rye from tool cache for ${version}...`);
    const cachedVersions = tc.findAllVersions(utils_1.toolsCacheName, arch);
    core.debug(`Cached versions: ${cachedVersions}`);
    return tc.find(utils_1.toolsCacheName, version, arch);
}
exports.tryGetFromCache = tryGetFromCache;
function downloadVersion(platform, arch, version, checkSum, githubToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const binary = `rye-${arch}-${platform}`;
        let downloadUrl = `https://github.com/${utils_1.OWNER}/${utils_1.REPO}/releases/download/${version}/${binary}`;
        if (platform === 'windows') {
            downloadUrl += '.exe';
        }
        else {
            downloadUrl += '.gz';
        }
        core.info(`Downloading Rye from "${downloadUrl}" ...`);
        let downloadPath = yield tc.downloadTool(downloadUrl, undefined, githubToken);
        yield (0, utils_1.validateChecksum)(checkSum, downloadPath, arch, platform, version);
        if (platform === 'windows') {
            // On Windows, the downloaded file is an executable, so we don't need to extract it
            // but the file must has a valid extension for an executable file.
            yield io.mv(downloadPath, `${downloadPath}.exe`);
            downloadPath = `${downloadPath}.exe`;
        }
        else {
            yield (0, utils_1.extract)(downloadPath);
        }
        return downloadPath;
    });
}
exports.downloadVersion = downloadVersion;
